<template>
  <input 
    type="url" 
    ref="input" 
    :value="value" 
    @input="$emit('input', $refs.input.value)"
  >
</template>

<script>
export default {
  name: 'iUrlField',
  props: ['value'],
};
</script>

